import React, { createContext, useContext, useEffect, useState } from "react";
import { decryptData } from "./Encryption";

// Context बनाएं
const PermissionContext = createContext(null);

export const PermissionProvider = ({ children }) => {
    const [permissions, setPermissions] = useState({});
    const [fullAccess, setFullAccess] = useState("N");

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
                const encrypted = JSON.parse(sessionStorage.getItem("ADMIN-PERMISSION"));

                if (encrypted) {
                    const decrypted = await decryptData(encrypted);
                    const parsedPermissions = JSON.parse(decrypted);
                    setPermissions(parsedPermissions);
                }

                setFullAccess(user?.admin_type === "Super Admin" ? "Y" : "N");
            } catch (error) {
                console.error("Error fetching permissions:", error);
                setPermissions({});
                setFullAccess("N");
            }
        };

        fetchPermissions();
    }, []);

    return (
        <PermissionContext.Provider value={{ fullAccess, permissions }}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermissions = (type) => {
    const context = useContext(PermissionContext);
    if (!context) {
        throw new Error("usePermissions must be used within a PermissionProvider");
    }
    const { fullAccess, permissions } = context;
    return {
        fullAccess,
        ...(permissions?.[type] || {})
    };
};
